import defaultApi from '@/utils/request';

export default {
  Load(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_category/Load',
      params,
    });
  },
  LoadNewsCategory(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_category/LoadNewsCategory',
      params,
    });
  },
  Get(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_category/Get',
      params,
    });
  },
  Add(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_category/Add',
      data,
    });
  },
  Update(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_category/Update',
      data,
    });
  },
  Del(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_category/Delete',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data,
    });
  },
  SelectData(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_category/SelectData',
      params,
    });
  },
  SelectAllData(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_category/SelectAllData',
      params,
    });
  },
};
